module.exports = __webpack_public_path__ + "assets/img/tx102a_4.79260c32.jpg";